<script>
    import {getStyleValue} from "../../Common/tools";
    import TextEditor from "../../Common/TextEditor.svelte";
    import CouponCode from "./CouponCode.svelte";

    export let data, meta, globalStyle, onChange;

    function change(val) {
      onChange();
      data = Object.assign({}, data, {content: val});
    }
</script>

<tr>
    <th class="column"
        style="padding-left: 40px; padding-right: 40px; font-weight: 400; text-align: left;"
        width="{getStyleValue(globalStyle.width, 600)}">
        <TextEditor data={data.content} meta={meta} onChange={change} emailEditor={true} />
        <CouponCode globalStyle={globalStyle} data={data} isChild={true}/>
    </th>
</tr>
